import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { NavController, NavParams, Events, ModalController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from '../../services/ebsWebServiceGlobals';
import { EmailPage } from "../../pages/email/email";

@Component({
  selector: 'grid-box-component',
  templateUrl: 'grid-box.html',
  inputs: ['gridBoxData', 'showMultiselect']
})
export class GridBoxComponent implements AfterViewInit {

  gridBoxData: any;
  gridBoxDataProcessed: any;
  colorDesign: string = "";
  selected = false;
  bodyNotClickable = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public _ebsComponentService: EbsComponentService,
    public _ebsWebService: EbsWebService,
    private cdRef: ChangeDetectorRef,
    public events: Events,
    public modalCtrl: ModalController,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals) {
    this.colorDesign = this._ebsWebServiceGlobals.getColorDesign();
  }

  ngAfterViewInit(): void {
    this.gridBoxDataProcessed = this._ebsWebService.prepareWebServiceDataForView(this.gridBoxData);

    if (this.gridBoxData.Dynamic != null) {
      if (typeof this.gridBoxData.Dynamic.GridColor != "undefined" && this.gridBoxData.Dynamic.GridColor != null) {
        this.gridBoxData.BorderColor = this.gridBoxData.Dynamic.GridColor + " 12px solid";
      } else {
        this.gridBoxData.BorderColor = "transparent 12px solid";
      }
      if (typeof this.gridBoxData.Dynamic.BackgroundColor != "undefined" && this.gridBoxData.Dynamic.BackgroundColor != null) {
        this.gridBoxData.BackgroundColor = this.gridBoxData.Dynamic.BackgroundColor;
      }
      if (typeof this.gridBoxData.Dynamic.BodyNotClickable != "undefined" && this.gridBoxData.Dynamic.BodyNotClickable != null && this.gridBoxData.Dynamic.BodyNotClickable == "True") {
        this.bodyNotClickable = true;
      }
    }

    this.cdRef.detectChanges();
    this.events.subscribe('event:DeselectAllItems', () => {
      this.gridBoxData.IsSelected = false;
      this.cdRef.detectChanges();
    });
  }

  ionViewDidLoad() {
    this.cdRef.detectChanges();
  }

  openPage(element) {
    console.log(element, 'element');
    if (element.Action == null) {
      return;
    }

    if (element.ViewTypeAction == "Link") {
      let params = JSON.parse(this._ebsWebService.buildPostPayloadObjectFromGetParameters(element.PostParameters));
      console.log(params);
      window.open(params.action);
    } else {
      if (typeof element.Dynamic != "undefined" && element.Dynamic != null && element.Dynamic.NotClickable != null && element.Dynamic.NotClickable == "True" && element.Dynamic.NotClickable != "") {
        return;
      }

      let navParams = {
        title: this.gridBoxData.Caption,
        actionURL: element.Action,
        postParams: element.PostParameters,
        caption: this.gridBoxData.Caption
      };

      let customNavElments = element.ListItemContent.filter(item =>
        item.Dynamic != null &&
        item.Dynamic.CustomNav != null &&
        item.Dynamic.CustomNav == "true");

      if (customNavElments.length != 0) {
        let customNavElement = customNavElments[0];
        console.log(customNavElement);
        let emailData = JSON.parse(customNavElement.EditValue.replace(/\\/g, "\\\\"));
        let profileModal = this.modalCtrl.create(EmailPage, {
          receiver: emailData.Receiver,
          subject: emailData.Subject,
          body: emailData.Body,
          data: customNavElement,
          fileAttachementOptional: emailData.FileAttachmentOptional || '',
          fileAttachementCustom: emailData.FileAttachment || '',
          customRedirectNavparams: navParams,
          customRedirectElement: element,
          customRedirectNavCtrl: this.navCtrl
        });
        profileModal.present();
      } else {
        this._ebsComponentService.navigationController(element, navParams, this.navCtrl);
      }
    }
  }

  selectItem(selected, item) {
    if (selected) {
      this.gridBoxData.IsSelected = true;
      this.events.publish('event:ItemSelected', item);
    } else {
      this.gridBoxData.IsSelected = false;
      this.events.publish('event:ItemDeselected', item);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/grid-box/grid-box.ts